/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLaborCostRequest } from '../../models/create-labor-cost-request';
import { LaborCostDto } from '../../models/labor-cost-dto';

export interface CreateLaborCost$Params {
      body: CreateLaborCostRequest
}

export function createLaborCost(http: HttpClient, rootUrl: string, params: CreateLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, createLaborCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborCostDto>;
    })
  );
}

createLaborCost.PATH = '/v0/laborCosts/{id}';
